import { createSelector } from 'reselect'

import { getApiAccounts, getApiMembers } from '../api/selectors'
import {
  getCurrentAccount,
  getCurrentAccountId, getCurrentCredentialId, getCurrentMemberId
} from 'reduxes/slices/current/selectors'

export const getHandlesIndexedByMemberId = createSelector(
  [getApiMembers, getApiAccounts],
  (members, accounts) => {
    return Object.values(members).reduce((acc, member) => {
      const handle = accounts[member.account_id]?.handle
      if (handle) {
        acc[member.id] = handle
      }
      return acc
    }, {})
  },
)

export const getDisplayedMembers = createSelector(
  [getApiMembers],
  (members) => {
    return Object.values(members)
      .filter((m) => m.displayed)
      .sort((a, b) => a.sort_order - b.sort_order)
  },
)

export const getAccountMembers = createSelector(
  [getApiMembers, getCurrentAccountId],
  (members, currentAccountId) => {
    return Object.values(members)
      .filter((m) => m.displayed && m.account_id === currentAccountId)
      .sort((a, b) => a.sort_order - b.sort_order)
  }
)

export const getMemberIds = createSelector([getApiMembers], (members) => {
  return Object.values(members).map((member) => member.id)
})
